/**
 * Модель виджета «Работы хозяйства и карта» (вкладка «Агроциклы и работы»).
 * Ничего не пересчитывает: итоги работы — ответ `/season/picture` с
 * `actor_id` (уже суженные до хозяйства), здесь только порядок строк.
 *
 * Порядок — по положению среза относительно окна, как на странице агроцикла
 * (решение владельца 08.10: «активные сверху, давно закрытые вниз»):
 * 1. окно идёт и работа не закрыта — ближайший конец окна выше;
 * 2. окно идёт, всё уже выполнено;
 * 3. окно закрыто, есть недоотчёт (после срока) — недавние выше;
 * 4. окно впереди — ближайшее начало выше;
 * 5. окно закрыто, всё выполнено — давно закрытые в самом низу.
 */
import { workPhase, type CampaignWork } from './model';

export function farmWorkRank(w: CampaignWork, asOf: string): number {
  const phase = workPhase(w, asOf);
  const open = (!w.window_from || w.window_from <= asOf) && (!w.window_to || w.window_to >= asOf);
  if (phase === 'ahead') return 3;
  if (open) return phase === 'done' ? 1 : 0;
  return phase === 'done' ? 4 : 2;
}

export function sortFarmWorks(works: ReadonlyArray<CampaignWork>, asOf: string): CampaignWork[] {
  const key = (w: CampaignWork) => {
    const rank = farmWorkRank(w, asOf);
    // Внутри группы: идущие и впереди — по ближайшей дате вперёд, закрытые — недавние выше.
    const date = rank === 3 ? w.window_from ?? '' : w.window_to ?? '';
    return { rank, date, desc: rank === 2 || rank === 4 };
  };
  return [...works].sort((a, b) => {
    const ka = key(a);
    const kb = key(b);
    if (ka.rank !== kb.rank) return ka.rank - kb.rank;
    const byDate = ka.desc ? kb.date.localeCompare(ka.date) : ka.date.localeCompare(kb.date);
    return byDate || a.campaign_id - b.campaign_id;
  });
}
